export const getClassCountTuitionBillingId = (
  billingInfo: { _id: string } | string | null | undefined,
) => {
  if (!billingInfo) return null;
  return typeof billingInfo === 'object' ? billingInfo._id : billingInfo;
};
